import { SubscriptionContext } from "../contexts/SubscriptionContext";
import { useContext } from "react";

const useAccountSubscription = () => {
  const context = useContext(SubscriptionContext);

  if (!context)
    throw new Error(
      "SubscriptionContext must be placed within SubscriptionContextProvider"
    );

  return context;
};

export default useAccountSubscription;
